import type { SVGProps } from "react";
export interface ChessIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChessIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChessIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.874 22v-3c0-.538.263-.977.463-1.253a6.5 6.5 0 0 1 .784-.861c.286-.272.61-.555.93-.834a43 43 0 0 0 .968-.861c.646-.598 1.168-1.16 1.473-1.688q.055-.098.098-.187a9.7 9.7 0 0 1-1.928.612l-.347.066c-1.158.198-2.175-.384-2.753-1.216l-.11-.17-.193-.322a3.13 3.13 0 0 1 .26-3.587l3.237-3.956-.516-1.795c-.37-1.286.87-2.4 2.07-1.994l.239.101 1.54.8c2.738-.183 5.281.66 6.954 2.494 1.73 1.896 2.363 4.665 1.549 7.924a29.6 29.6 0 0 0-.854 6.076c-.027.869-.001 1.611.06 2.18q.046.425.108.68c.043.178.075.24.07.234a1.124 1.124 0 0 1-1.952 1.116c-.27-.47-.396-1.149-.465-1.79a19 19 0 0 1-.07-2.489c.058-1.886.336-4.217.92-6.552.67-2.684.094-4.632-1.028-5.862-1.142-1.253-3.016-1.945-5.283-1.758a1.65 1.65 0 0 1-.673-.084l-.217-.094-.406-.21.207.717.044.194c.062.39-.021.79-.232 1.123l-.116.161-3.443 4.209a.875.875 0 0 0-.074 1.003l.194.324.067.095c.16.203.355.253.486.23l.573-.12c.608-.15 1.306-.4 1.957-.809l.14-.079a1.65 1.65 0 0 1 1.095-.14c.392.086.78.334 1.008.748l.088.19.073.212c.326 1.058.034 2.05-.43 2.852-.481.834-1.214 1.584-1.892 2.212-.345.32-.698.626-1.018.905a28 28 0 0 0-.858.77c-.25.237-.415.416-.511.55q-.023.033-.036.055v2.879a1.126 1.126 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="m20 20.875.115.006a1.125 1.125 0 0 1 0 2.238l-.114.006H4a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
